// React
import { useState } from "react";

// @mui material components
import { Card, Collapse, Icon, Tab, Tabs } from "@mui/material";

import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DatosEmpresa from "./DatosEmpresa";
import MediosDePago from "./MediosDePago";

function Preferencias() {
  const [selectedTab, setSelectedTab] = useState("Preferencias");
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox p={3}>
              <Tabs
                value={selectedTab}
                onChange={(e, value) => {
                  setSelectedTab(value);
                }}
              >
                <Tab
                  label={
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox display="flex" alignItems="center">
                        <Icon color={selectedTab === "Preferencias" ? "primary" : "secondary"}>
                          receipt
                        </Icon>
                      </SoftBox>
                      <SoftTypography
                        variant="h6"
                        fontWeight={selectedTab === "Preferencias" ? "bold" : "regular"}
                      >
                        Empresa
                      </SoftTypography>
                    </SoftBox>
                  }
                  value={"Preferencias"}
                />
                <Tab
                  label={
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox display="flex" alignItems="center">
                        <Icon color={selectedTab === "Medios de Pago" ? "primary" : "secondary"}>
                          table_restaurant
                        </Icon>
                      </SoftBox>
                      <SoftTypography
                        variant="h6"
                        fontWeight={selectedTab === "Medios de Pago" ? "bold" : "regular"}
                      >
                        Medios de Pago
                      </SoftTypography>
                    </SoftBox>
                  }
                  value={"Medios de Pago"}
                />
              </Tabs>
            </SoftBox>
            <SoftBox p={3} pt={0}>
              <Collapse in={selectedTab === "Preferencias"} unmountOnExit>
                <DatosEmpresa />
              </Collapse>
              <Collapse in={selectedTab === "Medios de Pago"} unmountOnExit>
                <MediosDePago />
              </Collapse>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Preferencias;
